module.exports = __webpack_public_path__ + "static/media/footer-2.2c69f06a.svg";